import { render, staticRenderFns } from "./NewAuthLayout.vue?vue&type=template&id=12bc6a62"
import script from "./NewAuthLayout.vue?vue&type=script&lang=js"
export * from "./NewAuthLayout.vue?vue&type=script&lang=js"
import style0 from "./NewAuthLayout.vue?vue&type=style&index=0&id=12bc6a62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports